import { FC, SVGProps } from 'react'

import { ReactComponent as delivery } from 'Icons/fulfillment/delivery.svg'
import { ReactComponent as pickup } from 'Icons/fulfillment/pickup.svg'
import { ReactComponent as shipping } from 'Icons/fulfillment/shipping.svg'
import { ReactComponent as tableside } from 'Icons/fulfillment/tableside.svg'

export default {
  pickup,
  delivery,
  shipping,
  tableside,
} as { [key: string]: FC<SVGProps<SVGSVGElement>> }
